import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Custom text-* utilities from src/styles/utilities.css. Without these groups
// tailwind-merge classifies them as text colors, so a later color class (e.g.
// text-destructive) would silently drop them.
const twMerge = extendTailwindMerge<"text-numeric">({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "h1",
            "h2",
            "h3",
            "h4",
            "h4-semi",
            "h5",
            "h5-medium",
            "h6",
            "section-title",
            "card-title",
            "body-lg",
            "body",
            "body-medium",
            "body-semibold",
            "meta",
            "tag-lg",
            "tag-sm",
          ],
        },
      ],
      "text-numeric": ["text-numeric"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
